import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb from 'components/Common/Breadcrumb2';
import CreateModule from './CreateModule';
import ModuleTable from './ModuleTable';
import Select from 'react-select';
import { fetchCoursesRequest, fetchModulesRequest, addModuleRequest, getRoles } from 'store/actions';

const ModuleList = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const modules = useSelector(state => state.Module.modules);
  const courses = useSelector(state => state.Course.courses);
  const loading = useSelector(state => state.Module.loading);
  const error = useSelector(state => state.Module.error);
  const roles = useSelector(state => state?.Role.roles);

  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const hasAddPermission = permissions?.some(item => item?.permission_name === 'Add Module');

  useEffect(() => {
    dispatch(fetchCoursesRequest());
    dispatch(getRoles());
  }, [dispatch]);

  const handleSubmit = (data, onClose) => {
    dispatch(addModuleRequest(data, onClose));
  };
  // Prepare options for react-select
  const courseOptions = courses?.data?.map(course => ({
    value: course._id,
    label: course.title
  })) || [];

  return (
    <>
      <CreateModule
        visible={isOpen}
        handleClose={() => setIsOpen(false)}
        onSubmit={handleSubmit}
        courses={courses?.data || []}
      />

      <div className="page-content container-fluid">
        <div className="d-flex justify-content-between align-items-center mx-3 mb-3">
          <Breadcrumb
            title="Modules"
            breadcrumbItems={[
              { title: 'Dashboard', link: '/dashboard' },
              { title: 'Modules', link: '#' }
            ]}
          />

          {hasAddPermission && (
            <Button
              className="bg-primary text-white d-flex align-items-center gap-1"
              onClick={() => setIsOpen(true)}
            >
              <i className="ti-plus"></i> Add New
            </Button>
          )}
        </div>

        {/* Course Selector for Filtering */}

        <ModuleTable
          modules={modules?.data || []}
          totalrows={modules?.total}
          loading={loading}
          error={error}
          courses={courses?.data}
          courseOptions={courseOptions}
        />
      </div>
    </>
  );
};

export default ModuleList;
